import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ServiceDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

        return	<section className="service-details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 clearfix">
                        <img src={publicUrl+"assets/images/resources/accurate-intelligent.jpg"} alt={ imagealt } className="float-right wow fadeInLeft" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>Accurate & Intelligent Responses</h3>
                            <p>Converzex.ai uses advanced AI technology to understand customer intent, context, and behavior in real time, enabling faster, smarter, and more natural conversations. Our intelligent Chat Agent and voice agents deliver accurate responses instantly, helping businesses provide consistent support while reducing manual workload.</p>
                            <p>Whether customers are asking about services, pricing, availability, or support, the system responds with precision and clarity while maintaining a human-like conversational flow. By continuously learning from interactions and data patterns, the AI becomes smarter over time, improving response quality, customer satisfaction, and lead conversion rates.</p>

                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
                
            </div>{/* /.container */}
        </section>

    }
}

export default ServiceDetails